export const propertiesEnum = {
  TimeReference: 'TimeReference',
  Days: 'Days',
  Percent: 'Percent',
  Amount: 'Amount',
  CurrencyId: 'CurrencyId',
  AmountOrPercentInDeposits: 'AmountOrPercentInDeposits',
  ApplyLowestCostOption: 'ApplyLowestCostOption',
  CancellationTime: 'CancellationTime'
};

export const sourceEnum = {
  deposits: 'deposits',
  cancellations: 'cancellations',
};

